// extracted by mini-css-extract-plugin
export default {"tableContainer":"htmlView_tableContainer__5tRh9"};